"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseService = exports.parseName = exports.findVersion = exports.findName = exports.findAndParseCapabilityUrl = exports.findAndParseAbstract = void 0;
var xml_utils_1 = require("xml-utils");
var xml_1 = require("./xml");
function findAndParseAbstract(xml, _a) {
    var _b = _a === void 0 ? { trim: true } : _a, _c = _b.trim, trim = _c === void 0 ? true : _c;
    var abstract = (0, xml_1.findTagText)(xml, "Abstract");
    if (!abstract) {
        return undefined;
    }
    if (trim) {
        // eslint-disable-next-line fp/no-mutation
        abstract = abstract.trim();
    }
    return abstract;
}
exports.findAndParseAbstract = findAndParseAbstract;
function findAndParseCapabilityUrl(xml, capability) {
    var onlineResource = (0, xml_utils_1.findTagByPath)(xml, [
        "Capability",
        "Request",
        capability,
        "OnlineResource",
    ]);
    if (onlineResource) {
        return (0, xml_utils_1.getAttribute)(onlineResource.outer, "xlink:href");
    }
    return undefined;
}
exports.findAndParseCapabilityUrl = findAndParseCapabilityUrl;
function findName(xml) {
    return (0, xml_1.findTagText)(xml, "Name");
}
exports.findName = findName;
function findVersion(xml) {
    var tagNames = [
        // wcs
        "WCS_Capabilities",
        "wcs:Capabilities",
        "wcs:CoverageDescriptions",
        "wcs:CoverageDescription",
        "CoverageDescriptions",
        "CoverageDescription",
        // wms
        "WMS_Capabilities",
        "WMT_MS_Capabilities",
        // wfs
        "wfs:WFS_Capabilities",
        // other
        "ServiceExceptionReport",
    ];
    for (var i = 0; i < tagNames.length; i += 1) {
        var tagName = tagNames[i];
        var tag = (0, xml_utils_1.findTagByName)(xml, tagName);
        if (tag) {
            var version = (0, xml_utils_1.getAttribute)(tag.outer, "version");
            if (version) {
                return version;
            }
        }
    }
    // if haven't found version yet, try to grab it from the wcs:xmlns attribute
    for (var i = 0; i < tagNames.length; i += 1) {
        var tagName = tagNames[i];
        var tag = (0, xml_utils_1.findTagByName)(xml, tagName);
        if (tag) {
            var link = (0, xml_utils_1.getAttribute)(tag.outer, "xmlns:wcs");
            if (link.endsWith("2.0")) {
                return "2.0.0";
            }
        }
    }
    return undefined;
}
exports.findVersion = findVersion;
function parseName(name) {
    if (name.includes("__") || name.includes(":")) {
        var _a = __read(name.split(/(__|:)/), 3), namespace = _a[0], short = _a[2];
        return { full: name, namespace: namespace, short: short };
    }
    return { full: name, namespace: undefined, short: name };
}
exports.parseName = parseName;
function parseService(url, options) {
    var _a = new URL(url), pathname = _a.pathname, searchParams = _a.searchParams;
    if (searchParams.has("service") && searchParams.get("service") !== "") {
        var service = searchParams.get("service"); // we know it's not null because of searchParams.has('service')
        switch (options === null || options === void 0 ? void 0 : options.case) {
            case "lower":
                return service.toLowerCase();
            case "upper":
                return service.toUpperCase();
            default:
                return service;
        }
    }
    var match = /(wcs|wfs|wms|wmts|wps)\/?$/i.exec(pathname);
    if (match) {
        var service = match[0];
        switch (options === null || options === void 0 ? void 0 : options.case) {
            case "lower":
                return service.toLowerCase();
            case "upper":
                return service.toUpperCase();
            default:
                return service;
        }
    }
    return undefined;
}
exports.parseService = parseService;
